var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.125,
    height: 14,
    viewBox: "0 0 13.125 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar",
    "data-name": "Icon metro-calendar",
    d: "M6.946,7.178H8.7v1.75H6.946Zm2.625,0h1.75v1.75H9.571Zm2.625,0h1.75v1.75H12.2Zm-7.875,5.25h1.75v1.75H4.321Zm2.625,0H8.7v1.75H6.946Zm2.625,0h1.75v1.75H9.571ZM6.946,9.8H8.7v1.75H6.946Zm2.625,0h1.75v1.75H9.571Zm2.625,0h1.75v1.75H12.2Zm-7.875,0h1.75v1.75H4.321Zm9.625-7.875V2.8H12.2V1.928H6.071V2.8H4.321V1.928H2.571v14H15.7v-14h-1.75Zm.875,13.125H3.446V5.428H14.821Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#8ea8bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fe3f3bf66650720b99fbc415118bea6e.svg";
export { ForwardRef as ReactComponent };